<template>
  <div class="container">
    <router-view />
    <Tool />
    <GlobalDialog />
  </div>
</template>
<script>
import Tool from './components/Tool.vue';
import GlobalDialog from './components/GlobalDialog.vue';
export default {
  name: 'App',
  components: {
    Tool,
    GlobalDialog,
  },
  mounted() {
    this.$store.dispatch('getDict');
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 去除谷歌浏览器input输入框选中情况下的背景色 */
input:-webkit-autofill {
  transition: background-color 500000s ease-in-out 0s;
}
</style>
